<template>
  <div class="summary">
      <div class="wrap">
      <h3>{{meta}}</h3> 
      <h1>{{title}}</h1>
      <p>{{body}}</p>
      </div>
  </div>
</template>

<script>
export default {
  name: "summary",
  data() {
    return {
      title: "The stratas of product development",
      body:
        "Our multidisciplinary team has mastered the art of delivering enterprise software solutions that empower organizations. We think far beyond delivering features, and focus on truly supporting humans in the context of their work. Our model necessitates that business, technology and end user needs carry equal weight, and that knowledge from these domains is continuously integrated throughout the project lifecycle. We are design driven, and believe failure is predictable and avoidable by validating proposed solutions with users every step of the way."
    };
  }
};
</script>

<style lang="scss" scoped>
.summary {
  text-align: center;
  padding-top: 36px;
          @media (max-width: 700px) {
  padding: 36px 16px 0 16px;
      }
}
h3 {
  color: #111215;
  font-size: 24.38px;
  line-height: 29px;
  text-align: center;
  font-weight: 200;
  display: block;
  width: 100%;
  margin: 0;
            @media (max-width: 700px) {
              font-size: 16px;
      }
}
h1 {
  color: #111215;
  font-size: 35.93px;
  font-weight: 600;
  letter-spacing: 0.25px;
  line-height: 43px;
  text-align: center;
  display: block;
  width: 100%;
  margin: 0;
            @media (max-width: 700px) {
              font-size: 32px;
              line-height: 38px;
      }
}

p {
  color: rgba(17, 18, 21, 0.6);
  font-family: Rubik;
  font-size: 16.26px;
  letter-spacing: 0.5px;
  line-height: 28px;
  text-align: center;
  display: block;
  max-width: 830px;
  margin: 0 auto;
  margin-top: 27px;
}
</style>